import { ComponentType } from 'react';
import { ToggleComponent } from '../../../featureToggle';
import GroupManagerLayout from './GroupManagerLayout';
import FreshwatchGroupManagerLayoutSimple from '../../../customized/fresh-watch/components/Group/FreshwatchGroupManagerLayout';

export default ToggleComponent(GroupManagerLayout, {
  styledComponentsVariants: {
    'fresh-watch': FreshwatchGroupManagerLayoutSimple,
  },
});
